import _getters from '@/store/modules/getters'
import _mutations from '@/store/modules/mutations'
import client from '@/base/api/client'
// import SysUtils from '@/base/utils/SysUtils'

const mutations = Object.assign({}, _mutations)
const getters = Object.assign({}, _getters)

mutations.FIND_COUNTS = function (state, payload) {
  state.counts = payload
}

const state = {
  rows: [],
  row: {},
  condition: {},
  counts: {}
}

const actions = {
  init: ({ commit, state }, condition) => {
    const ctx = {
      data: {
        init: { api: 'FrameShopAdminHomeService.initCounts' }
      }
    }
    return client.postData(ctx)
      .then((data) => {
        commit('FIND_COUNTS', data.init.output)
      })
  }
}

const module = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default module
